module.exports = __webpack_public_path__ + "static/media/02-03.c613e63e.png";